import React from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';

import MediaTypography from 'components/MediaTypography';

import HomeIcon from '@common/assets/icons/home.svg';

import BREADCRUMB_ROUTE_CONFIG from './config';
import { CrumbButton, CrumbLink, Separator, Wrapper } from './styled';

function formatSegment(segment?: string) {
	if (!segment) return '';

	return segment
		.replace(/[-_]/g, ' ')
		.replace(/([a-z])([A-Z])/g, '$1 $2')
		.replace(/\b\w/g, (char) => char.toUpperCase());
}

function Breadcrumbs() {
	const navigate = useNavigate();
	const { pathname } = useLocation();
	const { t } = useTranslation();

	const normalizedPathname = pathname === '/' ? '/' : pathname.replace(/\/+$/, '');
	const isHomeRoute = normalizedPathname === '/' || normalizedPathname === '/home';
	const segments = normalizedPathname.split('/').filter(Boolean);
	const rootSegment = segments[0];
	const hasSubRoute = segments.length > 1;
	const rootPath = rootSegment ? `/${rootSegment}` : '';
	const routeConfig = rootPath ? BREADCRUMB_ROUTE_CONFIG[rootPath] : undefined;
	const label = routeConfig ? t(routeConfig.labelKey) : formatSegment(rootSegment);
	const rootHref = routeConfig?.href || rootPath;

	if (isHomeRoute || !rootSegment) {
		return null;
	}

	return (
		<Wrapper>
			<CrumbButton onClick={() => navigate('/home')} aria-label="Home" color="primary">
				<HomeIcon />
			</CrumbButton>
			<Separator aria-hidden="true">›</Separator>
			{hasSubRoute ? (
				<CrumbLink
					variant="subtitle2"
					component="button"
					sx={{ lineHeight: 1 }}
					onClick={() => navigate(rootHref)}
				>
					{label}
				</CrumbLink>
			) : (
				<MediaTypography variant="subtitle2" sx={{ lineHeight: 1 }}>
					{label}
				</MediaTypography>
			)}
		</Wrapper>
	);
}

export default Breadcrumbs;
